import { toRaw, type InjectionKey, inject } from 'vue';

export const UrlGeneratorInjectionKey = Symbol('UrlGenerator') as InjectionKey<UrlGenerator>;

export class UrlGenerator {
  private readonly base: string;

  constructor(base: string) {
    this.base = base;
  }

  public generate(uri: string, params?: Record<string, any>, hash?: string, base?: string | null) {
    const url = new URL(uri, base || this.base);

    if (params) {
      this.attachSearchParameters(url.searchParams, params);
    }

    if (hash) {
      url.hash = hash;
    }

    return url.toString();
  }

  public isCrossOriginTarget(target: string) {
    try {
      let targetLocation = new URL(target);
      let currentOrigin = window.location.host;
      let targetOrigin = targetLocation.host;

      return currentOrigin !== targetOrigin;
    } catch (e) {
      return false;
    }
  }

  private attachSearchParameters(search: URLSearchParams, params: Record<string, any>) {
    Object.keys(params).forEach((key) => {
      this.appendSearchParameter(search, key, toRaw(params[key]));
    });
  }


  private appendSearchParameter(search: URLSearchParams, name: string, value: any, prev?: string) {
    if (prev) {
      name = prev + '[' + name + ']';
    }

    if (value == null) {
      search.set(name, '');
      return search;
    }

    if (Array.isArray(value)) {
      value.forEach((arrValue, arrIndex) => {
        this.appendSearchParameter(search, arrIndex.toString(), arrValue, name);
      });

      return search;
    }

    if (typeof value === 'object') {
      Object.keys(value).forEach((key) => {
        this.appendSearchParameter(search, key, value[key], name);
      });

      return search;
    }

    if (typeof value === 'boolean') {
      value = Number(value);
    }

    if (value == null) {
      value = '';
    }

    search.set(name, value);

    return search;
  }
}

export function useUrlGenerator() {
  return inject(UrlGeneratorInjectionKey)!;
}
